

import React from 'react'
import { BoxWrapper } from '../../../style'
import { goBack } from '../../../Utils/common';
import arrowIcon from "../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import LoanCalculator from '../../../components/LoanCalculator/LoanCalculator';
import { ArrowLeft } from "lucide-react";
function CalculateLoan() {
  const navigate = useNavigate();

  return (

    <BoxWrapper className="w100 gray" >
      <div className="formmainBox flex justify-center ">
        <div className="left">
          <div className='center gap4 pointer text-center inline-block mb-5 pointer border border-blue-500 rounded-lg px-6 py-1 group hover:bg-gray-100 hover:bg-blue-50 transition-all duration-300' onClick={() => goBack(navigate, "/my-dashboard/eligibility")}>
            <ArrowLeft size={18} className='inline w-4 mr-1 text-blue-600 group-hover:-translate-x-1 transition-all duration-300' /><span className='font-medium text-black text-blue-600 '>Back</span>
          </div>


        </div>

        <div className="right ">
          <h2 className='font-bold text-[#1B2A57]  '>CALCULATING LOANS</h2>

          <LoanCalculator />
        </div>
      </div>

    </BoxWrapper>
  )
}

export default CalculateLoan;